import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const FamilyTimeline = () => {
  const timelineEvents = [
  {
    year: "1985",
    title: "The Beginning",
    description: "Giuseppe and Maria Montesanto opened the first bakery in Etobicoke, bringing authentic Italian recipes passed down through four generations. Starting with just a small oven and big dreams, they introduced the neighborhood to real Italian cornetti and focaccia.",
    image: "https://images.unsplash.com/photo-1600973259156-16298e64a792",
    imageAlt: "Vintage black and white photograph of elderly Italian couple in traditional baker's attire standing proudly in front of their small bakery storefront with wooden door and hand-painted signage",
    icon: "Home"
  },
  {
    year: "1992",
    title: "Community Roots",
    description: "The bakery became a neighborhood gathering place where locals would start their mornings with fresh espresso and warm pastries. We introduced our signature panettone during the holidays, which quickly became a Toronto tradition for Italian families.",
    image: "https://images.unsplash.com/photo-1659256018450-d335d49bf247",
    imageAlt: "Warm community scene showing diverse group of smiling customers gathered around bakery counter enjoying coffee and pastries together in cozy vintage Italian cafe setting with checkered tablecloths",
    icon: "Users"
  },
  {
    year: "2003",
    title: "Next Generation",
    description: "Marco and Sofia Montesanto joined the family business, bringing fresh energy while honoring traditional methods. They expanded our offerings to include custom celebration cakes and catering services, blending old-world craftsmanship with modern customer needs.",
    image: "https://images.unsplash.com/photo-1565128542755-7fe9c3ebf177",
    imageAlt: "Young Italian couple in professional baker's uniforms working together kneading dough on marble counter in bright modern bakery kitchen with stainless steel equipment and flour-dusted surfaces",
    icon: "Sparkles"
  },
  {
    year: "2015",
    title: "Artisan Excellence",
    description: "We renovated and expanded, adding a dedicated pastry kitchen and gelato station. Our commitment to using imported Italian ingredients and traditional techniques earned recognition across Toronto, with food critics praising our authentic approach.",
    image: "https://images.unsplash.com/photo-1543060625-8ad3aa33a339",
    imageAlt: "Modern artisan bakery interior showcasing gleaming display cases filled with colorful Italian pastries and gelato, professional espresso machine, and elegant marble countertops under warm pendant lighting",
    icon: "Award"
  },
  {
    year: "2025",
    title: "Today & Tomorrow",
    description: "Now serving our third generation of customers, we continue Giuseppe and Maria's vision: creating authentic Italian moments that bring people together. Every morning, we still hand-roll our cornetti and proof our focaccia using the same recipes from 1985.",
    image: "https://images.unsplash.com/photo-1623814877285-846d8f309845",
    imageAlt: "Contemporary bustling bakery scene with multi-generational family of bakers working together, customers browsing displays of fresh breads and pastries, warm lighting creating inviting atmosphere in spacious modern Italian bakery",
    icon: "Heart"
  }];


  return (
    <section className="py-20 bg-background">
      <div className="container-custom">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent/10 border border-accent/20 mb-4">
            <Icon name="Clock" size={18} color="var(--color-accent)" />
            <span className="text-sm font-medium text-accent">40 Years of Heritage</span>
          </div>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-foreground mb-4">
            Our Family Journey
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Four decades of passion, tradition, and community connection—from a small family dream to an Etobicoke institution
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-1/2 top-0 bottom-0 w-0.5 bg-gradient-to-b from-primary via-accent to-primary hidden lg:block" />

          <div className="space-y-16">
            {timelineEvents?.map((event, index) =>
            <div
              key={event?.year}
              className={`relative flex flex-col lg:flex-row gap-8 items-center ${
              index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'}`
              }>

                <div className="w-full lg:w-5/12">
                  <div className="bg-card rounded-2xl p-6 shadow-warm hover:shadow-warm-lg transition-all duration-300">
                    <div className="flex items-center gap-3 mb-4">
                      <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
                        <Icon name={event?.icon} size={24} color="var(--color-primary)" />
                      </div>
                      <span className="font-accent text-3xl text-primary font-bold">
                        {event?.year}
                      </span>
                    </div>
                    <h3 className="font-serif text-2xl font-semibold text-foreground mb-3">
                      {event?.title}
                    </h3>
                    <p className="text-muted-foreground leading-relaxed">
                      {event?.description}
                    </p>
                  </div>
                </div>

                <div className="hidden lg:flex w-2/12 justify-center">
                  <div className="w-16 h-16 rounded-full bg-primary border-4 border-background shadow-warm flex items-center justify-center">
                    <Icon name={event?.icon} size={28} color="var(--color-primary-foreground)" />
                  </div>
                </div>

                <div className="w-full lg:w-5/12">
                  <div className="relative rounded-2xl overflow-hidden shadow-warm hover:shadow-warm-lg transition-all duration-300 group">
                    <div className="aspect-[4/3] overflow-hidden">
                      <Image
                      src={event?.image}
                      alt={event?.imageAlt}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />

                    </div>
                    <div className="absolute inset-0 bg-gradient-to-t from-primary/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>);

};

export default FamilyTimeline;